import { AuthProvider } from 'react-oidc-context';
import { useLocation } from "react-router-dom";
import { Config } from "../Config";
import CookiesBlocker from "./CookiesBlocker/CookiesBlocker";
import React from 'react';
import ErrorPage from '../pages/ErrorPage';
import { UserType, V5Origin } from '../services/Types';
import { User, UserManager, UserManagerSettings } from 'oidc-client-ts';
import { useCookies } from 'react-cookie';

const AuthProviderWithHistory = ({ children }: any) => {

    const error : any = {error: "Authorizaton Error", description: "Cannot configure authorization."};
    
    let query = useQuery();
    
    const userType = query.get("type") ? query.get("type") : null;  
    const origin = query.get("origin_client") ? query.get("origin_client") : null;
    const credentialId = query.get("credential_id") ? query.get("credential_id") : null;
    const [cookies, setCookie] = useCookies(["credentialId"]);
        
    try {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        window.sessionStorage.length;
    } catch {
        return <CookiesBlocker />;
    }

    const onSigninCallback = (_user: User | void): void => {      
      window.history.replaceState(
          {},          
          document.title,
          buildCallbackUri(window.location.pathname, userType, origin, cookies.credentialId))
    }

    let userManagerSettings : UserManagerSettings = {
      authority: '',
      client_id: '',
      redirect_uri: ''
    };

    if (userType && origin && userType === UserType.EXTERNAL)
    {
      userManagerSettings  = {
        authority: Config.auth_external.domain,
        client_id: Config.auth_external.clientId,      
        redirect_uri: buildRedirectUri(userType ? userType: "", origin),        
        post_logout_redirect_uri: buildPostLogoutRedirectUri(origin),   
        response_mode: "query",
        scope: "openid profile email read:credential create:credential_email update:credential read:question_answer read:credential_log read:brand read:permission account-mapping uca-id"
      };
    }  

    if (userType && origin && userType === UserType.INTERNAL)
    {
      userManagerSettings  = {
        authority: Config.auth_internal.domain,
        client_id: Config.auth_internal.clientId,      
        redirect_uri: buildRedirectUri(userType ? userType: "", origin),
        response_mode: "query",
        scope: Config.auth_internal.scopes
      };
    }

    let userManager = new UserManager(userManagerSettings);
    
    return (
        userType && origin && (userType === UserType.EXTERNAL || userType === UserType.INTERNAL) ?
        <AuthProvider          
          userManager={userManager}
          onSigninCallback={onSigninCallback}
        >
          {children}
        </AuthProvider>
      :        
         <>          
          <ErrorPage error={error} />
        </>
    );
}

function useQuery() {
    const { search } = useLocation();
  
    return React.useMemo(() => new URLSearchParams(search), [search]);
}
  
function buildPostLogoutRedirectUri(origin: string | null) : string {
  
  let postLogoutRedirectUri = `${window.location.origin}/support-modal?type=external`;
      
  if(origin && origin === V5Origin.SERVICE && Config.v5.serviceSiteLogoutUrl)
  {
    postLogoutRedirectUri = Config.v5.serviceSiteLogoutUrl;
  }
      
  if(origin && origin === V5Origin.EMPLOYER && Config.v5.employerSiteLogoutUrl)
  {
    postLogoutRedirectUri = Config.v5.employerSiteLogoutUrl;
  }
    
  return postLogoutRedirectUri;
}

function buildRedirectUri(userType: string | null, origin: string | null) : string {
  
  let redirectUri = `${window.location.origin}/support-modal`;

  if(userType && userType === UserType.EXTERNAL)
  {
    redirectUri += "?type=external";
  }

  if(userType && userType === UserType.INTERNAL)
  {
    redirectUri += "?type=internal";
  }
  
  if(origin && origin === V5Origin.SERVICE)
  {
    redirectUri += `&origin_client=${V5Origin.SERVICE}`;
  }
    
  if(origin && origin === V5Origin.EMPLOYER)
  {
    redirectUri += `&origin_client=${V5Origin.EMPLOYER}`;
  }
  
  return redirectUri;
} 

function buildCallbackUri(path: string, userType: string | null, origin: string | null, credentialId: string | null) : string {

let callbackUri = path;

if(userType)
{
  callbackUri += `?type=${userType}`;  
}

if(origin)
{
  callbackUri += `&origin_client=${origin}`;  
}

if(credentialId)
{
  callbackUri += `&credential_id=${credentialId}`;  
}

return callbackUri;
}
     
export default AuthProviderWithHistory;